// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"8ef83938","585":"1333649a"}[chunkId] + ".chunk.js";
};